import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { useParams } from "react-router-dom";

const Recipe = () => {
  const [recipe, setRecipe] = useState({});
  const [activeTab, setActiveTab] = useState("Instructions");
  let params = useParams();

  useEffect(() => {
    const fetchDetails = async () => {
      const data = await fetch(
        `https://api.spoonacular.com/recipes/${params.id}/information?apiKey=${process.env.REACT_APP_API_KEY}`
      );
      const recipe = await data.json();
      setRecipe(recipe);
    };
    fetchDetails(params.id);
  }, [params.id]);

  return (
    <DetailWrapper>
      <div>
        <h2>{recipe.title}</h2>
        <img src={recipe.image} alt={recipe.title} />
      </div>
      <Info>
        <Button
          className={activeTab === "Instructions" ? "active" : ""}
          onClick={() => setActiveTab("Instructions")}
        >
          Instructions
        </Button>
        <Button
          className={activeTab === "Ingredients" ? "active" : ""}
          onClick={() => setActiveTab("Ingredients")}
        >
          Ingredients
        </Button>
        {activeTab === "Instructions" && (
          <div>
            <p dangerouslySetInnerHTML={{ __html: recipe.summary }}></p>
            <p dangerouslySetInnerHTML={{ __html: recipe.instructions }}></p>
          </div>
        )}
        {activeTab === "Ingredients" && (
          <ul>
            {recipe.extendedIngredients.map((Ingredient) => {
              return <li key={Ingredient.id}>{Ingredient.original}</li>;
            })}
          </ul>
        )}
      </Info>
    </DetailWrapper>
  );
};

const DetailWrapper = styled.div`
  margin: 1rem 0rem;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(25rem, 1fr));
  .active {
    background: linear-gradient(35deg, #494949, #313131);
    color: white;
  }
  img {
    width: 100%;
    border-radius: 2rem;
  }
  h2 {
    margin: 1rem 0rem;
  }
  li {
    font-size: 1.2rem;
    line-height: 2.5rem;
  }
  ul {
    margin-top: 2rem;
  }
  @media screen and (max-width: 970px) {
    grid-template-columns: repeat(auto-fit, minmax(15rem, 1fr));
    h2 {
      font-size: 1rem;
      padding: 0px 10px;
    }
    img {
      height: 300px;
    }
  }
  @media screen and (max-width: 600px) {
    align-items: center;
    justify-content: center;
    img {
      width: 100%;
      height: 200px;
    }
  }
`;

const Button = styled.button`
  padding: 1rem 2rem;
  color: #313131;
  background: white;
  border: 2px solid black;
  margin-right: 2rem;
  margin-bottom: 1rem;
  font-weight: 600;
  cursor: pointer;
  @media screen and (max-width: 800px) {
    padding: 0.5rem 0.5rem;
    margin-right: 1rem;
    font-size: 0.6rem;
    border: 1px solid black;
  }
`;
const Info = styled.div`
  margin-left: 5rem;
  margin-top: 1rem;
  p {
    padding: 0px 20px;
  }
  @media screen and (max-width: 960px) {
    margin-left: 0rem;
    p {
      font-size: 0.7rem;
    }
    ul {
      font-size: 0.6rem;
      padding: 0px 20px;
    }
  }
`;

export default Recipe;
